import React, {useEffect, useState} from 'react';
import {url} from '../../../utils/variables';
import ImagePickerModal from '../../master/ImagePickerModal';
import {uploadImages} from '../../../utils/functions';
import { t } from 'i18next';
// import AddImageOutline from '../../../assets/images/add-image-outline.png';
// import LicenseCard from '../../../assets/images/AddImagePlaceholder/add-front-license.png'
// import BackCard from '../../../assets/images/AddImagePlaceholder/add-back-license.png'
// import VehicleCard from '../../../assets/images/AddImagePlaceholder/add-front-vehicle-card.png'
// import ThirdInsurance from '../../../assets/images/AddImagePlaceholder/add-third-insurance.png'
// import BodyInsurance from '../../../assets/images/AddImagePlaceholder/add-body-insurance.png'

export default function UserDocs({ data ,step ,hasBodyInsurance }) {

    const [attachments, setAttachments] = useState({});
    // const imagePlaceholders = {
    //     'license_image' : LicenseCard,
    //     'back' : BackCard,
    //     'vehicle_card_image' : VehicleCard,
    //     'third_image' : ThirdInsurance,
    //     'body_image' : BodyInsurance,
    // };

    useEffect(() => {
        if (!data.attachments) return;
        const images = data.attachments.reduce((prev, current) => ({
            ...prev,
            [current.filename]: current,
        }), {});
        setAttachments(images);
    }, [data.attachments]);

    function finishUpload(image, name, done) {
        uploadImages({
            id: data.id,
            type: 'user',
            name,
            image,
            done,
            callback: (img) => {
                setAttachments(prevState => ({
                    ...prevState,
                    [name]: img,
                }));
            },
        });
    }
    function renderButton(name) {
        return(
            attachments[name]?.uid ?
                <img
                    src={`${url}/files?uid=${attachments[name].uid}&width=150&height=150`}
                    className='img'
                    alt='img'
                />
                : 
                'default'
                // <div className='upload-icon-parent'>
                //     <img src={name.includes('back') ? imagePlaceholders['back']:imagePlaceholders[name]}/>
                // </div>
        )
    }

    return (
        <div className='gridParent'>
            {step === 0 && (
                <>
            <div className={`${step === 0 ? 'docsGrid profile-step active ' : 'docsGrid profile-step'}`}>
                <div className='gridChild'>
                    <p>{t('License image')}</p>
                    <div className='imgParent'>
                        <div className='flex1'>
                            <ImagePickerModal
                                // renderBtn={
                                //     attachments.license_image ?
                                //         <img
                                //             src={`${url}/files?uid=${attachments.license_image.uid}&width=150&height=150`}
                                //             className='img'
                                //             alt='img'
                                //         />
                                //         : 
                                        // <div className='defaultImage' data-content={t('Add')}/>
                                //         <div className='upload-icon-parent'>
                                //             <img src={AddImageOutline}/>
                                //         </div>
                                // }
                                renderBtn={renderButton('license_image')}
                                upload={(image, done) => finishUpload(image, 'license_image', done)}
                                label='license_image'
                                imageUid={attachments.license_image}
                            />
                        </div>
                        {/* <div className='flex1' /> */}
                    </div>
                </div>
            </div>
            <div className={`${step === 0 ? 'docsGrid profile-step active ' : 'docsGrid profile-step'}`}>
                <div className='gridChild'>
                    <p>{t('Back License image')}</p>
                    <div className='imgParent'>
                        <div className='flex1'>
                            <ImagePickerModal
                                // renderBtn={
                                //     attachments.license_back_image ?
                                //         <img
                                //             src={`${url}/files?uid=${attachments.license_back_image.uid}&width=150&height=150`}
                                //             className='img'
                                //             alt='img'
                                //         />
                                //         : 
                                //         <div className='upload-icon-parent'>
                                //             <img src={AddImageOutline}/>
                                //         </div>
                                //         // <div className='defaultImage' data-content={t('Add')}/>
                                // }
                                renderBtn={renderButton('license_back_image')}
                                upload={(image, done) => finishUpload(image, 'license_back_image', done)}
                                label='back_license_image'
                                imageUid={attachments.license_back_image}
                            />
                        </div>
                        {/* <div className='flex1' /> */}
                    </div>
                </div>
            </div>
            </>
            )}
            {step === 1 && (
                <>
            <div className={`${step === 1 ? 'docsGrid profile-step active ' : 'docsGrid profile-step'}`}>
                <div className='gridChild'>
                    <p >{t('Vehicle card image')}</p>
                    <div className='imgParent'>
                        <div className='flex1'>
                            <ImagePickerModal
                                // renderBtn={
                                //     attachments.vehicle_card_image ?
                                //         <img
                                //             src={`${url}/files?uid=${attachments.vehicle_card_image.uid}&width=150&height=150`}
                                //             className='img'
                                //             alt='img'
                                //         />
                                //         : 
                                //         <div className='upload-icon-parent'>
                                //             <img src={AddImageOutline}/>
                                //         </div>
                                //         // <div className='defaultImage' data-content={t('Add')}/>
                                // }
                                renderBtn={renderButton('vehicle_card_image')}
                                upload={(image, done) => finishUpload(image, 'vehicle_card_image', done)}
                                label='vehicle_card_image'
                                imageUid={attachments.vehicle_card_image}
                            />
                        </div>
                        {/* <div className='flex1' /> */}
                    </div>
                </div>
            </div>
            <div className={`${step === 1 ? 'docsGrid profile-step active ' : 'docsGrid profile-step'}`}>
                <div className='gridChild'>
                    <p>{t('Back vehicle card image')}</p>
                    <div className='imgParent'>
                        <div className='flex1'>
                            <ImagePickerModal
                                // renderBtn={
                                //     attachments.vehicle_card_back_image ?
                                //         <img
                                //             src={`${url}/files?uid=${attachments.vehicle_card_back_image.uid}&width=150&height=150`}
                                //             className='img'
                                //             alt='img'
                                //         />
                                //         : 
                                //         <div className='upload-icon-parent'>
                                //             <img src={AddImageOutline}/>
                                //         </div>
                                //         //<div className='defaultImage' data-content={t('Add')}/>
                                // }
                                renderBtn={renderButton('vehicle_card_back_image')}
                                upload={(image, done) => finishUpload(image, 'vehicle_card_back_image', done)}
                                label='vehicle_card_back_image'
                                imageUid={attachments.vehicle_card_back_image}
                            />
                        </div>
                        {/* <div className='flex1' /> */}
                    </div>
                </div>
            </div>
            </>
            )}
            {step === 2 && (
                <>
            <div className={`${step === 2 ? 'docsGrid profile-step active ' : 'docsGrid profile-step'}`}>
                <div className='gridChild'>
                    <p>{t('Third insurance image')}</p>
                    <div className='imgParent'>
                        <div className='flex1'>
                            <ImagePickerModal
                                // renderBtn={
                                //     attachments.third_image ?
                                //         <img
                                //             src={`${url}/files?uid=${attachments.third_image.uid}&width=150&height=150`}
                                //             className='img'
                                //             alt='img'
                                //         />
                                //         : 
                                //         <div className='upload-icon-parent'>
                                //             <img src={AddImageOutline}/>
                                //         </div>
                                //         //<div className='defaultImage' data-content={t('Add')}/>
                                // }
                                renderBtn={renderButton('third_image')}
                                upload={(image, done) => finishUpload(image, 'third_image', done)}
                                label='third_image'
                                imageUid={attachments.third_image}
                            />
                        </div>
                        {/* <div className='flex1' /> */}
                    </div>
                </div>
            </div>
            {hasBodyInsurance && (
                        <div className={`${step === 2 ? 'docsGrid profile-step active ' : 'docsGrid profile-step'}`}>
                            <div className='gridChild'>
                                <p>{t('Body insurance image')}</p>
                                <div className='imgParent'>
                                    <div className='flex1'>
                                        <ImagePickerModal
                                            // renderBtn={
                                            //     attachments.body_image ?
                                            //         <img
                                            //             src={`${url}/files?uid=${attachments.body_image.uid}&width=150&height=150`}
                                            //             className='img'
                                            //             alt='img'
                                            //         />
                                            //         : 
                                            //         <div className='upload-icon-parent'>
                                            //             <img src={AddImageOutline}/>
                                            //         </div>
                                            //         //<div className='defaultImage' data-content={t('Add')}/>
                                            // }
                                            renderBtn={renderButton('body_image')}
                                            upload={(image, done) => finishUpload(image, 'body_image', done)}
                                            label='body_image'
                                            imageUid={attachments.body_image}
                                        />
                                    </div>
                                    {/* <div className='flex1' /> */}
                                </div>
                            </div>
                        </div>
                    )}
            </>
            )}
        </div>
    );
}
